import { Component, HostBinding, Input } from '@angular/core';
import { FuseNavigationService } from '../../navigation.service';

@Component({
    selector   : 'fuse-nav-horizontal-item',
    templateUrl: './item.component.html',
    styleUrls  : ['./item.component.scss']
})
export class FuseNavHorizontalItemComponent
{
    @HostBinding('class')
    classes = 'nav-item';

    @Input()
    item: any;

    /**
     * Constructor
     */
    constructor(
        public _fuseNavigationService: FuseNavigationService        
    )
    {

    }
}
